/* unplugin-vue-components disabled */import { render } from "./dropdown.vue?vue&type=template&id=60fcfbc1&scoped=true"
import script from "./dropdown.vue?vue&type=script&lang=js"
export * from "./dropdown.vue?vue&type=script&lang=js"

import "./dropdown.vue?vue&type=style&index=0&id=60fcfbc1&lang=stylus&scoped=true"
import "./dropdown.vue?vue&type=style&index=1&id=60fcfbc1&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fcfbc1"],['__file',"src/controls/dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60fcfbc1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60fcfbc1', __exports__)) {
    api.reload('60fcfbc1', __exports__)
  }
  
  module.hot.accept("./dropdown.vue?vue&type=template&id=60fcfbc1&scoped=true", () => {
    api.rerender('60fcfbc1', render)
  })

}


export default __exports__